
import React, { useContext, useEffect, useState, ReactNode } from 'react';
import { useUserController } from '@/User/ui/hooks/useUserController';
import { createApiUserRepository } from '@/User/infrastructure/ApiUserRepository';
import { WebTagPermissionsContext, WebTagPermissionsContextType } from './WebTagPermissionsContext';
import { useUserData } from '../ui/context';

export const WebTagPermissionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { user, } = useUserData();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const repository = createApiUserRepository();
  const { getPermissions } = useUserController(repository);

  useEffect(() => {
    if (user.user !== null) {
      getPermissions().then(perms => {
        setPermissions(perms);
        setIsLoading(false);
      });
    }
  }, [user]);

  const hasPermission = (tag: string): boolean => permissions.includes(tag);

  return (
    <WebTagPermissionsContext.Provider value={{ permissions, isLoading, hasPermission }}>
      {children}
    </WebTagPermissionsContext.Provider>
  );
};

export const useWebTagPermissions = (): WebTagPermissionsContextType =>
  useContext(WebTagPermissionsContext);